import React from 'react';

import { ReactComponent as AttachmentIcon } from 'assets/icons/attachment-new.svg';
import StyledTooltip from 'components/StyledTooltip/StyledTooltip';

interface Props {
  prop1?: string;
}

// This is a dummy component. Once attachments are enabled, need to add logic here.
const AttachmentElement: React.FC<Props> = ({ prop1 = '' }) => {
  return (
    <StyledTooltip
      tagName="div"
      direction="left"
      content={
        <p style={{ textAlign: 'left', padding: '10px' }}>
          <div className="text-label" style={{ padding: '0px 0px 20px 0px' }}>
            Attachments: {prop1}
          </div>
          <div>Attachment1.doc</div>
        </p>
      }
    >
      <AttachmentIcon />
    </StyledTooltip>
  );
};

export default AttachmentElement;
